import { render, staticRenderFns } from "./curriculum_detail.vue?vue&type=template&id=b77d5304&"
import script from "./curriculum_detail.vue?vue&type=script&lang=js&"
export * from "./curriculum_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports